import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';
import { APIS } from 'scbk-shared-module/constants/apiPaths';

import type {
  GetNonFaceAuthInfoRequest,
  GetNonFaceAuthInfoResponse,
  RemoteIdvCheckInfo,
  RemoteIdvCheckParam,
} from 'scbk-shared-module';

/**
 * 고객정보 조회
 * @param mutationOptions
 * @returns
 */
export function useSvcMemGetCustInfo(
  mutationOptions?: UseRestPostMutationOptions<RemoteIdvCheckParam, RemoteIdvCheckInfo>,
) {
  return useRestPost<RemoteIdvCheckParam, RemoteIdvCheckInfo>(
    {
      endpoint: APIS.services.member.findDetail.getCustInfo,
    },
    mutationOptions,
  );
}

/**
 * 비대면 인증 정보 조회
 * @param mutationOptions
 * @returns
 */
export function useGetNonFaceAuthInfo(
  mutationOptions?: UseRestPostMutationOptions<
    GetNonFaceAuthInfoRequest,
    GetNonFaceAuthInfoResponse
  >,
) {
  return useRestPost<GetNonFaceAuthInfoRequest, GetNonFaceAuthInfoResponse>(
    {
      endpoint: APIS.auth.identity.ocr.getNonFaceAuthInfo,
    },
    mutationOptions,
  );
}
